// Inyectar el botón al cargar el DOM
document.addEventListener('DOMContentLoaded', function () {
    // Crear botón
    const scrollBtn = document.createElement('a');
    // Cambio: se usa un ícono de Bootstrap en lugar de texto
    scrollBtn.innerHTML = '<i class="fa fa-chevron-up"></i>';
    scrollBtn.id = 'scrollTopBtn';
    // Estilos básicos modificados para botón circular verde
    scrollBtn.style.position = 'fixed';
    scrollBtn.style.right = '22px';
    scrollBtn.style.display = 'none';
    scrollBtn.style.width = '50px';
    scrollBtn.style.height = '50px';
    scrollBtn.style.borderRadius = '50%';
    scrollBtn.style.background = '#28a745';
    scrollBtn.style.color = '#fff';
    scrollBtn.style.border = 'none';
    scrollBtn.style.cursor = 'pointer';
    scrollBtn.style.fontSize = '20px';
    scrollBtn.style.alignItems = 'center';
    scrollBtn.style.zIndex = '7';
    scrollBtn.style.justifyContent = 'center';
    // Posición inferior inicial
    scrollBtn.style.bottom = '30px';
    // Agregar botón al body
    document.body.appendChild(scrollBtn);

    // Mostrar/ocultar botón y ajustar su posición para no pasarse del footer
    window.addEventListener('scroll', function () {
        // Mostrar u ocultar boton
        if (window.pageYOffset > 200) {
            scrollBtn.style.display = 'flex';
        } else {
            scrollBtn.style.display = 'none';
        }

        // Ajustar posición: si el footer es visible, elevar el botón
        const footer = document.getElementById('footer');
        if (footer) {
            const footerRect = footer.getBoundingClientRect();
            const bottomMargin = 80; // margen deseado desde el final de la ventana
            if (footerRect.top < window.innerHeight - bottomMargin) {
                // Calcula el solapamiento y ajusta
                let overlap = window.innerHeight - bottomMargin - footerRect.top + 20;
                scrollBtn.style.bottom = (bottomMargin + overlap) + 'px';
            } else {
                scrollBtn.style.bottom = bottomMargin + 'px';
            }
        }
    });

    // Evento click: scroll suave hacia arriba
    scrollBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
});
